import { render, staticRenderFns } from "./OtherContactInfomation.vue?vue&type=template&id=fd35465c"
import script from "./OtherContactInfomation.vue?vue&type=script&lang=ts"
export * from "./OtherContactInfomation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports